import { CreatedByUser } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/components/CreatedByUser';
import { DeviceTrackingLogType } from '@/api/apis/route';
import { DEVICE_TRACKING_LOG_NAME } from './consts';
import { getTrackingDevice, isGroundTrackingNodeLog } from './utils';
import { TrackingDeviceInfo } from './TrackingDeviceInfo';
import { TrackingLogs } from './TrackingLogs';
import { GroundTrackingLog } from './GroundTrackingLog';

type DeviceTrackingLogItemProps = {
  log: DeviceTrackingLogType;
};

export const DeviceTrackingLogItem = ({ log }: DeviceTrackingLogItemProps) => {
  const trackingDevice = getTrackingDevice(log);
  const isGroundNodeLog = isGroundTrackingNodeLog(log);

  return (
    <div id={log.logId} className="flex flex-col py-2 px-4 gap-2 rounded-lg bg-base-80">
      <span className="text-m-sb text-base-5">{DEVICE_TRACKING_LOG_NAME[log.$type]}</span>
      {trackingDevice && <TrackingDeviceInfo device={trackingDevice} />}
      {isGroundNodeLog ? <GroundTrackingLog log={log} /> : <TrackingLogs log={log} />}
      <CreatedByUser user={log.createdBy} timestamp={log.createdAt} />
    </div>
  );
};
